"use strict";
// DO NOT EDIT. Generated by gitlab.com/accumulatenetwork/accumulate/tools/cmd/gen-types.
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceType = exports.RecordType = exports.QueryType = exports.KnownPeerStatus = exports.EventType = void 0;
/* eslint-disable @typescript-eslint/no-namespace */
var EventType;
(function (EventType) {
    /** Error . */
    EventType[EventType["Error"] = 1] = "Error";
    /** Block . */
    EventType[EventType["Block"] = 2] = "Block";
    /** Globals . */
    EventType[EventType["Globals"] = 3] = "Globals";
})(EventType = exports.EventType || (exports.EventType = {}));
/** @ignore */
(function (EventType) {
    function fromObject(obj) {
        if (typeof obj === "number")
            return obj;
        return byName(obj);
    }
    EventType.fromObject = fromObject;
    function byName(name) {
        switch (name.toLowerCase()) {
            case "error":
                return EventType.Error;
            case "block":
                return EventType.Block;
            case "globals":
                return EventType.Globals;
            default:
                throw new Error(`Unknown EventType '${name}'`);
        }
    }
    EventType.byName = byName;
    function getName(v) {
        switch (v) {
            case EventType.Error:
                return "error";
            case EventType.Block:
                return "block";
            case EventType.Globals:
                return "globals";
            default:
                throw new Error(`Unknown EventType ${v}`);
        }
    }
    EventType.getName = getName;
})(EventType = exports.EventType || (exports.EventType = {}));
var KnownPeerStatus;
(function (KnownPeerStatus) {
    /** Unknown . */
    KnownPeerStatus[KnownPeerStatus["Unknown"] = 0] = "Unknown";
    /** Good . */
    KnownPeerStatus[KnownPeerStatus["Good"] = 1] = "Good";
    /** Bad . */
    KnownPeerStatus[KnownPeerStatus["Bad"] = 2] = "Bad";
})(KnownPeerStatus = exports.KnownPeerStatus || (exports.KnownPeerStatus = {}));
/** @ignore */
(function (KnownPeerStatus) {
    function fromObject(obj) {
        if (typeof obj === "number")
            return obj;
        return byName(obj);
    }
    KnownPeerStatus.fromObject = fromObject;
    function byName(name) {
        switch (name.toLowerCase()) {
            case "unknown":
                return KnownPeerStatus.Unknown;
            case "good":
                return KnownPeerStatus.Good;
            case "bad":
                return KnownPeerStatus.Bad;
            default:
                throw new Error(`Unknown KnownPeerStatus '${name}'`);
        }
    }
    KnownPeerStatus.byName = byName;
    function getName(v) {
        switch (v) {
            case KnownPeerStatus.Unknown:
                return "unknown";
            case KnownPeerStatus.Good:
                return "good";
            case KnownPeerStatus.Bad:
                return "bad";
            default:
                throw new Error(`Unknown KnownPeerStatus ${v}`);
        }
    }
    KnownPeerStatus.getName = getName;
})(KnownPeerStatus = exports.KnownPeerStatus || (exports.KnownPeerStatus = {}));
var QueryType;
(function (QueryType) {
    /** Default . */
    QueryType[QueryType["Default"] = 0] = "Default";
    /** Chain . */
    QueryType[QueryType["Chain"] = 1] = "Chain";
    /** Data . */
    QueryType[QueryType["Data"] = 2] = "Data";
    /** Directory . */
    QueryType[QueryType["Directory"] = 3] = "Directory";
    /** Pending . */
    QueryType[QueryType["Pending"] = 4] = "Pending";
    /** Block . */
    QueryType[QueryType["Block"] = 5] = "Block";
    /** AnchorSearch . */
    QueryType[QueryType["AnchorSearch"] = 16] = "AnchorSearch";
    /** PublicKeySearch . */
    QueryType[QueryType["PublicKeySearch"] = 17] = "PublicKeySearch";
    /** PublicKeyHashSearch . */
    QueryType[QueryType["PublicKeyHashSearch"] = 18] = "PublicKeyHashSearch";
    /** DelegateSearch . */
    QueryType[QueryType["DelegateSearch"] = 19] = "DelegateSearch";
    /** MessageHashSearch . */
    QueryType[QueryType["MessageHashSearch"] = 20] = "MessageHashSearch";
})(QueryType = exports.QueryType || (exports.QueryType = {}));
/** @ignore */
(function (QueryType) {
    function fromObject(obj) {
        if (typeof obj === "number")
            return obj;
        return byName(obj);
    }
    QueryType.fromObject = fromObject;
    function byName(name) {
        switch (name.toLowerCase()) {
            case "default":
                return QueryType.Default;
            case "chain":
                return QueryType.Chain;
            case "data":
                return QueryType.Data;
            case "directory":
                return QueryType.Directory;
            case "pending":
                return QueryType.Pending;
            case "block":
                return QueryType.Block;
            case "anchorsearch":
                return QueryType.AnchorSearch;
            case "publickeysearch":
                return QueryType.PublicKeySearch;
            case "publickeyhashsearch":
                return QueryType.PublicKeyHashSearch;
            case "delegatesearch":
                return QueryType.DelegateSearch;
            case "messagehashsearch":
                return QueryType.MessageHashSearch;
            default:
                throw new Error(`Unknown QueryType '${name}'`);
        }
    }
    QueryType.byName = byName;
    function getName(v) {
        switch (v) {
            case QueryType.Default:
                return "default";
            case QueryType.Chain:
                return "chain";
            case QueryType.Data:
                return "data";
            case QueryType.Directory:
                return "directory";
            case QueryType.Pending:
                return "pending";
            case QueryType.Block:
                return "block";
            case QueryType.AnchorSearch:
                return "anchorSearch";
            case QueryType.PublicKeySearch:
                return "publicKeySearch";
            case QueryType.PublicKeyHashSearch:
                return "publicKeyHashSearch";
            case QueryType.DelegateSearch:
                return "delegateSearch";
            case QueryType.MessageHashSearch:
                return "messageHashSearch";
            default:
                throw new Error(`Unknown QueryType ${v}`);
        }
    }
    QueryType.getName = getName;
})(QueryType = exports.QueryType || (exports.QueryType = {}));
var RecordType;
(function (RecordType) {
    /** Account . */
    RecordType[RecordType["Account"] = 1] = "Account";
    /** Chain . */
    RecordType[RecordType["Chain"] = 2] = "Chain";
    /** ChainEntry . */
    RecordType[RecordType["ChainEntry"] = 3] = "ChainEntry";
    /** Key . */
    RecordType[RecordType["Key"] = 4] = "Key";
    /** Message . */
    RecordType[RecordType["Message"] = 16] = "Message";
    /** SignatureSet . */
    RecordType[RecordType["SignatureSet"] = 17] = "SignatureSet";
    /** MinorBlock . */
    RecordType[RecordType["MinorBlock"] = 32] = "MinorBlock";
    /** MajorBlock . */
    RecordType[RecordType["MajorBlock"] = 33] = "MajorBlock";
    /** Range . */
    RecordType[RecordType["Range"] = 128] = "Range";
    /** Url . */
    RecordType[RecordType["Url"] = 129] = "Url";
    /** TxID . */
    RecordType[RecordType["TxID"] = 130] = "TxID";
    /** IndexEntry . */
    RecordType[RecordType["IndexEntry"] = 131] = "IndexEntry";
    /** Error . */
    RecordType[RecordType["Error"] = 143] = "Error";
})(RecordType = exports.RecordType || (exports.RecordType = {}));
/** @ignore */
(function (RecordType) {
    function fromObject(obj) {
        if (typeof obj === "number")
            return obj;
        return byName(obj);
    }
    RecordType.fromObject = fromObject;
    function byName(name) {
        switch (name.toLowerCase()) {
            case "account":
                return RecordType.Account;
            case "chain":
                return RecordType.Chain;
            case "chainentry":
                return RecordType.ChainEntry;
            case "key":
                return RecordType.Key;
            case "message":
                return RecordType.Message;
            case "signatureset":
                return RecordType.SignatureSet;
            case "minorblock":
                return RecordType.MinorBlock;
            case "majorblock":
                return RecordType.MajorBlock;
            case "range":
                return RecordType.Range;
            case "url":
                return RecordType.Url;
            case "txid":
                return RecordType.TxID;
            case "indexentry":
                return RecordType.IndexEntry;
            case "error":
                return RecordType.Error;
            default:
                throw new Error(`Unknown RecordType '${name}'`);
        }
    }
    RecordType.byName = byName;
    function getName(v) {
        switch (v) {
            case RecordType.Account:
                return "account";
            case RecordType.Chain:
                return "chain";
            case RecordType.ChainEntry:
                return "chainEntry";
            case RecordType.Key:
                return "key";
            case RecordType.Message:
                return "message";
            case RecordType.SignatureSet:
                return "signatureSet";
            case RecordType.MinorBlock:
                return "minorBlock";
            case RecordType.MajorBlock:
                return "majorBlock";
            case RecordType.Range:
                return "range";
            case RecordType.Url:
                return "url";
            case RecordType.TxID:
                return "txID";
            case RecordType.IndexEntry:
                return "indexEntry";
            case RecordType.Error:
                return "error";
            default:
                throw new Error(`Unknown RecordType ${v}`);
        }
    }
    RecordType.getName = getName;
})(RecordType = exports.RecordType || (exports.RecordType = {}));
var ServiceType;
(function (ServiceType) {
    /** Unknown indicates an unknown service type. */
    ServiceType[ServiceType["Unknown"] = 0] = "Unknown";
    /** Node is the type of [NodeService]. */
    ServiceType[ServiceType["Node"] = 1] = "Node";
    /** Consensus is the type of [ConsensusService]. */
    ServiceType[ServiceType["Consensus"] = 2] = "Consensus";
    /** Network is the type of [NetworkService]. */
    ServiceType[ServiceType["Network"] = 3] = "Network";
    /** Metrics is the type of [MetricsService]. */
    ServiceType[ServiceType["Metrics"] = 4] = "Metrics";
    /** Query is the type of [Querier]. */
    ServiceType[ServiceType["Query"] = 5] = "Query";
    /** Event is the type of [EventService]. */
    ServiceType[ServiceType["Event"] = 6] = "Event";
    /** Submit is the type of [Submitter]. */
    ServiceType[ServiceType["Submit"] = 7] = "Submit";
    /** Validate is the type of [Validator]. */
    ServiceType[ServiceType["Validate"] = 8] = "Validate";
    /** Faucet is the type of [Faucet]. */
    ServiceType[ServiceType["Faucet"] = 9] = "Faucet";
})(ServiceType = exports.ServiceType || (exports.ServiceType = {}));
/** @ignore */
(function (ServiceType) {
    function fromObject(obj) {
        if (typeof obj === "number")
            return obj;
        return byName(obj);
    }
    ServiceType.fromObject = fromObject;
    function byName(name) {
        switch (name.toLowerCase()) {
            case "unknown":
                return ServiceType.Unknown;
            case "node":
                return ServiceType.Node;
            case "consensus":
                return ServiceType.Consensus;
            case "network":
                return ServiceType.Network;
            case "metrics":
                return ServiceType.Metrics;
            case "query":
                return ServiceType.Query;
            case "event":
                return ServiceType.Event;
            case "submit":
                return ServiceType.Submit;
            case "validate":
                return ServiceType.Validate;
            case "faucet":
                return ServiceType.Faucet;
            default:
                throw new Error(`Unknown ServiceType '${name}'`);
        }
    }
    ServiceType.byName = byName;
    function getName(v) {
        switch (v) {
            case ServiceType.Unknown:
                return "unknown";
            case ServiceType.Node:
                return "node";
            case ServiceType.Consensus:
                return "consensus";
            case ServiceType.Network:
                return "network";
            case ServiceType.Metrics:
                return "metrics";
            case ServiceType.Query:
                return "query";
            case ServiceType.Event:
                return "event";
            case ServiceType.Submit:
                return "submit";
            case ServiceType.Validate:
                return "validate";
            case ServiceType.Faucet:
                return "faucet";
            default:
                throw new Error(`Unknown ServiceType ${v}`);
        }
    }
    ServiceType.getName = getName;
})(ServiceType = exports.ServiceType || (exports.ServiceType = {}));
//# sourceMappingURL=enums_gen.js.map